module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.23813",
      "conversations-internal-schema": "static-1.11644",
      "head-dlb": "static-1.4130",
      "hs-test-utils": "static-1.7009",
      "hubspot-url-utils": "static-1.3320",
      "HubStyleTokens": "static-2.10531",
      "I18n": "static-7.1402",
      "jasmine-runner": "static-1.5436",
      "quartz": "static-1.5768",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.466",
      "visitor-ui-component-library": "static-1.5203",
      "enviro": "static-4.310",
      "hs-promise-rejection-tracking": "static-1.4492",
      "PortalIdParser": "static-2.288",
      "raven": "static-3.4958",
      "raven-hubspot": "static-1.5265",
      "bend-plugin-trellis-migration": "static-1.2630",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1243",
      "hub-http": "static-1.4807",
      "immutable": "static-2.19",
      "immutable-less": "static-1.3576",
      "quartz-core": "static-1.4987",
      "transmute": "static-2.29",
      "HeadJS": "static-2.585",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.6266",
      "framer-motion": "static-1.42",
      "hs-test-utils-bend-plugin": "static-1.2120",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.124",
      "foundations-theming": "static-1-jm-subscribe-to-theme.29",
      "i18n-data": "static-1.199",
      "metrics-js": "static-1.8773",
      "moment-timezone": "static-5.51",
      "react-utils": "static-2.4495",
      "jasmine": "static-4.3365",
      "quartz-core-utils": "static-1.2635",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.40",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7478",
      "visitor-ui-component-library-icons": "static-1.5014",
      "bend-plugin-foundations-theming": "static-1-jm-subscribe-to-theme.29",
      "foundations-theming-base": "static-1-jm-subscribe-to-theme.29",
      "hs-story-utils": "static-1.8380",
      "rpc-client-utils": "static-1.3752",
      "ts-schema": "static-1.3286",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "copilot-toolkit": "static-1.7451",
      "dispatcher": "static-1.114",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.658",
      "hub-http-shared-msw-handlers": "static-1.7326",
      "hubspotter-http": "static-1.3760",
      "hubspotter-http-shared-msw-handlers": "static-1.7324",
      "icons": "static-2.592",
      "mobile-manifest-mixins": "static-1.356",
      "platform-navigation-bootstrap": "static-1.11437",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15576",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.332",
      "bend-plugin-foundations-components": "static-1.2535",
      "floating-ui": "static-1.30",
      "foundations-assets": "static-1.3916",
      "foundations-theming-specialty": "static-1-jm-subscribe-to-theme.29",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.75",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.893",
      "classnames": "static-2.10",
      "cssUtils": "static-1.534",
      "HubStyle": "static-2.10839",
      "chatspot-client-types": "static-1.9032",
      "chatspot-core": "static-1.16835",
      "sassPrefix": "static-1.133",
      "platform-infra-nav-components": "static-1.6872",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.23813",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11644",
      "head-dlb": "/head-dlb/static-1.4130",
      "hs-test-utils": "/hs-test-utils/static-1.7009",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3320",
      "HubStyleTokens": "/HubStyleTokens/static-2.10531",
      "I18n": "/I18n/static-7.1402",
      "jasmine-runner": "/jasmine-runner/static-1.5436",
      "quartz": "/quartz/static-1.5768",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.466",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5203",
      "enviro": "/enviro/static-4.310",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4492",
      "PortalIdParser": "/PortalIdParser/static-2.288",
      "raven": "/raven/static-3.4958",
      "raven-hubspot": "/raven-hubspot/static-1.5265",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2630",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1243",
      "hub-http": "/hub-http/static-1.4807",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.3576",
      "quartz-core": "/quartz-core/static-1.4987",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.585",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.6266",
      "framer-motion": "/framer-motion/static-1.42",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2120",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.124",
      "foundations-theming": "/foundations-theming/static-1-jm-subscribe-to-theme.29",
      "i18n-data": "/i18n-data/static-1.199",
      "metrics-js": "/metrics-js/static-1.8773",
      "moment-timezone": "/moment-timezone/static-5.51",
      "react-utils": "/react-utils/static-2.4495",
      "jasmine": "/jasmine/static-4.3365",
      "quartz-core-utils": "/quartz-core-utils/static-1.2635",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.40",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7478",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5014",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1-jm-subscribe-to-theme.29",
      "foundations-theming-base": "/foundations-theming-base/static-1-jm-subscribe-to-theme.29",
      "hs-story-utils": "/hs-story-utils/static-1.8380",
      "rpc-client-utils": "/rpc-client-utils/static-1.3752",
      "ts-schema": "/ts-schema/static-1.3286",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "copilot-toolkit": "/copilot-toolkit/static-1.7451",
      "dispatcher": "/dispatcher/static-1.114",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.658",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7326",
      "hubspotter-http": "/hubspotter-http/static-1.3760",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7324",
      "icons": "/icons/static-2.592",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.356",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11437",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15576",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.332",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2535",
      "floating-ui": "/floating-ui/static-1.30",
      "foundations-assets": "/foundations-assets/static-1.3916",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1-jm-subscribe-to-theme.29",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.75",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.893",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.534",
      "HubStyle": "/HubStyle/static-2.10839",
      "chatspot-client-types": "/chatspot-client-types/static-1.9032",
      "chatspot-core": "/chatspot-core/static-1.16835",
      "sassPrefix": "/sassPrefix/static-1.133",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6872",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};